export var featuredArticlesApiRelativePath = "/helpcenter/appearance/featuredArticles";
export var createFeaturedArticlesApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(featuredArticlesApiRelativePath);
    return {
        getFeaturedArticles: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.locale));
        },
        updateFeaturedArticles: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.locale), dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map